import React from "react";
import { Link } from "react-router-dom";

import { DashboardUser, UserAvatar } from "./user";

interface HeaderProps {
  user: DashboardUser;
}

export function Header({ user }: HeaderProps) {
  const displayName = user.fullname || user.email.split("@")[0] || "Tài khoản";

  return (
    <header className="w-full shrink-0 flex items-center justify-between gap-3 px-3 sm:px-4 md:px-6 py-2 md:py-3 z-20 relative bg-gradient-to-b from-[#0f172a]/80 to-transparent border-b border-gray-700/20">
      {/* Left: Logo & Company Name */}
      <div className="flex items-center space-x-2 sm:space-x-3 text-gray-300 min-w-0">
        <img
          src="https://khothi-cms.buso.asia/images/logo.png"
          alt="Khơ Thị Logo"
          className="h-6 sm:h-8 w-auto object-contain drop-shadow-md filter brightness-110 flex-shrink-0"
        />
        <span className="font-bold tracking-widest text-xs sm:text-sm uppercase text-gray-400 hidden sm:inline truncate">
          VIỆN THẨM MỸ KHƠ THỊ
        </span>
      </div>

      {/* Right: Thông báo · Tài khoản — màn rộng đã có ở thẻ cá nhân cột phải */}
      <div className="flex items-center gap-1 sm:gap-2 text-gray-400 xl:hidden">
        <Link
          to="/notifications"
          className="hover:text-white transition w-9 h-9 flex items-center justify-center rounded-full hover:bg-gray-700/40"
          aria-label="Thông báo"
          title="Thông báo"
        >
          <i className="fa-solid fa-bell text-sm sm:text-base" />
        </Link>

        <Link
          to="/admin/profile"
          className="hidden sm:flex items-center gap-2 bg-gray-800/50 hover:bg-gray-700/60 rounded-full py-1 pl-1 pr-3 transition"
          title="Thông tin cá nhân"
        >
          <UserAvatar user={user} size="sm" />
          <span className="text-gray-200 font-medium text-xs max-w-[140px] truncate">{displayName}</span>
        </Link>
      </div>
    </header>
  );
}
